// extracted by mini-css-extract-plugin
module.exports = {"c1mgr44y":"c1mgr44y","ctv128j":"ctv128j","c1tf3wts":"c1tf3wts","footer":"footer","n1jzi5h3":"n1jzi5h3","t5nffhs":"t5nffhs","tpaccnv":"tpaccnv","t1dw02t":"t1dw02t"};